import React, {FC} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {CheckBox} from '../../../../../libs/shared/ui/src/components/booleanInputs/checkBox';
import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {TooltipIconWithHover} from '../../../../analytics/components/reportElements/tooltips/analyticsTooltips';
import {BooleanParameter} from '../../../editors/commons/parameterModel';

/*
 * Props.
 */

interface InputBooleanProps {
  booleanParameter: BooleanParameter;
  currentValue: boolean;
  isDisabled?: boolean;
  onValueChange: HandlerOf<boolean>;
}

/*
 * Styles.
 */

const ParameterLineDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 0px 4px 0px;
`;

const CheckboxContainerDiv = styled.div`
  flex-grow: 1;
`;

const ManifestWrapper = styled.div`
  line-height: 18px;
`;

const StyledLink = styled.a`
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.medium};
`;

/*
 * Component.
 */

export const InputBoolean: FC<InputBooleanProps> = ({
  booleanParameter,
  currentValue,
  isDisabled,
  onValueChange,
}) => (
  <ParameterLineDiv>
    <CheckboxContainerDiv>
      <CheckBox
        isChecked={currentValue}
        onChange={() => onValueChange(!currentValue)}
        isDisabled={isDisabled}
      >
        {booleanParameter.title}
      </CheckBox>
    </CheckboxContainerDiv>
    {maybeRenderManifestHelperTooltip(booleanParameter.help)}
  </ParameterLineDiv>
);

/*
 * Helpers.
 */

const maybeRenderManifestHelperTooltip = (help: BooleanParameter['help']) => {
  if (!help) {
    return null;
  }

  return (
    <TooltipCoordinator
      render={() => (
        <ManifestWrapper>
          <p>{help.text}</p>
          <StyledLink href={help.link}>Learn more</StyledLink>
        </ManifestWrapper>
      )}
    >
      <TooltipIconWithHover />
    </TooltipCoordinator>
  );
};
